// extracted by mini-css-extract-plugin
export default {"box":"box_box__wZU9M","title":"box_title__x9Ukv","content":"box_content__MuHEZ","withTitle":"box_withTitle__GxDyW","actions":"box_actions__ZOTAj"};